import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../globals';
import { TakeawayServices } from '../../../takeaway/services';
import { OdsServices } from '../../../ods/services';
import { ConfigurationPaymentComerciaGlobalPayTopPage } from '../configuration-payment-comerciaglobalpay-top/configuration-payment-comerciaglobalpay-top';

/**
 * Generated class for the ConfigurationPaymentsComerciaGlobalPayPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-configuration-payments-comerciaglobalpay',
    templateUrl: 'configuration-payments-comerciaglobalpay.html',
})
export class ConfigurationPaymentsComerciaGlobalPayPage {

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public translate: TranslateService,
        public globals: Globals,
        public toastCtrl: ToastController,
        public odsServices: OdsServices,
        public takeawayServices: TakeawayServices) {
    }

    configComerciaGlobalPayTopPayment() {
        this.navCtrl.push(ConfigurationPaymentComerciaGlobalPayTopPage);
    }
}


// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-payment-methods/configuration-payments-comerciaglobalpay/configuration-payments-comerciaglobalpay.ts